import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { Modal } from "bootstrap";
import ReactDOM from "react-dom";
import { LoginForm } from "./loginForm";
import { CreateAccountAction } from "./createAccountAction";
import { useLocation } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const LoginRequiredModal = forwardRef(
  (
    {
      id = "loginModal",
      title = "Restricted Area",
      heading = "Please Login to Continue!",
      description = "Enter below details to continue your account",
      onClose,
    },
    ref,
  ) => {
    const { pathname } = useLocation();
    const isSignupPage = String(pathname).toLowerCase().startsWith(PAGES.SIGNUP);

    const modalRef = useRef(null);
    const modalInstance = useRef(null);

    useEffect(() => {
      if (modalRef.current) {
        modalInstance.current = new Modal(modalRef.current, {
          backdrop: "static",
          keyboard: false,
        });
      }
      return () => modalInstance.current?.dispose();
    }, []);

    const hide = () => {
      try {
        modalInstance.current?.hide();
      } catch (e) {
        console.error("Error hiding login modal:", e);
      }
    };

    useImperativeHandle(ref, () => ({
      show: () => modalInstance.current?.show(),
      hide,
    }));

    return ReactDOM.createPortal(
      <div
        className="modal fade"
        id={id}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
          <div className="modal-content">
            <p className="order-status-close" data-bs-dismiss="modal" onClick={onClose}>
              <i className="fa-regular fa-circle-xmark" />
            </p>
            <div className="modal-body p-0">
              <div className="product-found">
                <div className="product-found-title">
                  <i className="fa-regular fa-circle-user" />
                  <h4>{title}</h4>
                </div>
                <div className="product-found-body error-popup-body">
                  <div className="loginModal-popup">
                    <div className="loginModal-header text-center">
                      <h5>{heading}</h5>
                      <p className="fw-normal fs-14">{description}</p>
                    </div>
                    <LoginForm />
                    {!isSignupPage && <CreateAccountAction onNavigate={hide} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.body,
    );
  },
);
